export default __webpack_public_path__ + "static/media/arrow-right-black-icon.657f9b80.svg";